import { useState, useEffect } from 'react';
import api from '../../../services/api';
import './AdminSlider.css';

const AdminMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => { fetchMessages(); }, []);

  const fetchMessages = async () => {
    try {
      setLoading(true);
      const res = await api.get('/api/contact');
      setMessages(res.data);
    } catch { setError('Mesajlar yüklenemedi.'); }
    finally { setLoading(false); }
  };

  const handleMarkRead = async (id) => {
    try {
      await api.put(`/api/contact/${id}/read`);
      fetchMessages();
    } catch { setError('Güncelleme başarısız.'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Mesajı silmek istediğinizden emin misiniz?')) return;
    try {
      await api.delete(`/api/contact/${id}`);
      setSuccess('Mesaj silindi.');
      fetchMessages();
    } catch { setError('Silinemedi.'); }
  };

  if (loading) return <div className="admin-slider-empty">Yükleniyor...</div>;

  const unreadCount = messages.filter(m => !m.isRead).length;

  return (
    <div className="admin-slider">
      {success && <div className="admin-slider-success">{success}</div>}
      {error && <div className="admin-slider-error">{error}</div>}

      <div className="admin-slider-card">
        <div className="admin-slider-header">
          <h3>Mesajlar ({messages.length}) {unreadCount > 0 && <span style={{ color: '#3b82f6', fontSize: '0.8rem' }}>({unreadCount} okunmamış)</span>}</h3>
        </div>

        {messages.length > 0 ? (
          <div style={{ padding: '1rem 1.5rem', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {messages.map(msg => (
              <div key={msg._id} style={{ padding: '1rem', backgroundColor: msg.isRead ? '#2d3748' : '#374151', borderRadius: '0.5rem', borderLeft: msg.isRead ? '3px solid #4b5563' : '3px solid #3b82f6' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', marginBottom: '0.4rem' }}>
                      <strong style={{ color: '#f3f4f6', fontSize: '0.9rem' }}>{msg.name}</strong>
                      <span style={{ color: '#9ca3af', fontSize: '0.75rem' }}>{msg.email}</span>
                      {!msg.isRead && <span style={{ fontSize: '0.65rem', padding: '0.1rem 0.4rem', borderRadius: '9999px', backgroundColor: 'rgba(59,130,246,0.15)', color: '#60a5fa' }}>Yeni</span>}
                    </div>
                    <p style={{ color: '#60a5fa', fontSize: '0.8rem', margin: '0 0 0.3rem 0', fontWeight: '500' }}>{msg.subject}</p>
                    <p style={{ color: '#d1d5db', fontSize: '0.8rem', margin: '0 0 0.3rem 0', lineHeight: '1.5' }}>{msg.message}</p>
                    <p style={{ color: '#6b7280', fontSize: '0.65rem', margin: 0 }}>{new Date(msg.createdAt).toLocaleString('tr-TR')}</p>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem', flexShrink: 0 }}>
                    {!msg.isRead && <button className="admin-slider-btn-edit" onClick={() => handleMarkRead(msg._id)}>Okundu</button>}
                    <button className="admin-slider-btn-delete" onClick={() => handleDelete(msg._id)}>Sil</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="admin-slider-empty">Henüz mesaj yok.</div>
        )}
      </div>
    </div>
  );
};

export default AdminMessages;
